<script>
  import Home from "./Home.svelte";
  import About from "./About.svelte";
  import Skills from "./Skills.svelte";
  import Education from "./Education.svelte";
  import Portfolio from "./Portfolio.svelte";
  import Contact from "./Contact.svelte";
</script>

<main class="l-main">
  <Home />
  <About />
  <Portfolio />
  <Education />
</main>
